module.exports = __webpack_public_path__ + "static/media/1.a150d1e5.jpg";